const colors = {
  blueNCS: '#118AB2', // BLUE
  cadetBlueCrayola: '#ADB5BD', // GRAY
  carribeanGreen: '#06D6A0', // GREEN
  cultured: '#E9ECEF', // LIGHT GRAY
  orangeYellowCrayota: '#FFD166', // YELLOW
  paradisePink: '#EF476F', // PINK RED
  redCrayola: '#ED1D4D', // RED
  slateGray: '#6C757D', // DARK GRAY
  stackoverflowGold: '#FFCC01', // GOLD
  stackoverflowSilver: '#B4B8BC', // SILVER
  stackoverflowBronze: '#D1A684', // BRONZE
}

export default colors